import React from 'react';
import { mergeClassNames } from '../../utils/mergeClassNames';
import styles from './BoxList.module.scss';

export class BoxList extends React.Component
{

	render()
	{
		return (
			<ul className={mergeClassNames([this.props['className'], 'box-list'], styles)}>
				{
					this.props['children']?.map((v, i) => {
						return (
							<li key={i}>{v}</li>
						)
					})
				}
			</ul>
		)
	}
}